import {
  Cached,
  ErrorOutline,
  KeyboardArrowDown,
  OpenInNew,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Alert,
  Button,
  Checkbox,
  CircularProgress,
  InputAdornment,
  InputBase,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import {jwtDecode} from 'jwt-decode';
import { formatPhoneNumber } from "../utils/formatnumber";
import timezones from 'timezones-list';
import TimezoneSelect from "react-timezone-select"
import decryptApi from "../utils/decryptApi";
import encryptApi from "../utils/encryptApi";

const Organization = () => {
  const [org_data, setOrgData] = useState(JSON.parse(localStorage.getItem("organization")));
  //phone numbers
  const [incomming_phonenumbers, setIncommingPhonenumbers] = useState(null);
  const [loader1, setLoader1] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrormsg] = useState(null);
  const [loader, setLoader] = useState(false);

  async function decodeToken(token) {
    try {
      // Await the decryption result before returning it
      const decodedMessage = await decryptApi(token);
      return decodedMessage; // This will return the resolved value, not a promise
    } catch (error) {
      console.error('Invalid token:', error);
      return null;
    }
  }
  
  
  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };


  const [organization, setOrganization] = useState(
    // Sample Data
    {
      orgId: org_data.orgId.S,
      organization_name: org_data.organization_name.S,
      org_timezone: org_data.org_timezone.S,
      twilio_integration: {
        account_sid: org_data.twilio_integration.M.account_sid.S,
        api_key: "",
        transcription_enabled:
          org_data.twilio_integration.M.transcription_enabled.BOOL,
        auto_configuration:
          org_data.twilio_integration.M.auto_configuration.BOOL,
        primary_phone: org_data.twilio_integration.M.primary_phone.S,
        test_account: org_data.twilio_integration.M.test_account.BOOL,
      },
    }
  );
  
  useEffect(() => {
    const fetchDecodedToken = async () => {
      try {
        // Call the decodeToken function and wait for the result
        const decodedApiKey = org_data.twilio_integration.M.api_key.S;

        console.log({decodedApiKey})

        // Update the state with the decoded API key
        setOrganization((prevState) => ({
          ...prevState,
          twilio_integration: {
            ...prevState.twilio_integration,
            api_key: decodedApiKey,
          },
        }));
      } catch (error) {
        console.error('Error decoding API key:', error);
      }
    };

    fetchDecodedToken();
  }, [org_data]);


  async function getIncomingPhoneNumbers(apiSecret) {
    setLoader1(true);
    setErrormsg(null);
    
    if(organization.twilio_integration.account_sid ===  org_data.twilio_integration.M.account_sid.S  ){
      console.log('yes')
      
      await axios
      .post(
        process.env.REACT_APP_BACKEND_URL + "twilio/get-incoming-phone-numbers",
        organization.twilio_integration
      )
      .then((res) => {
        if (res.data.length < 1) {
          setErrormsg(
            "Please add an incoming phone number in your twilio account"
          );
          setLoader1(false);
        } else {
          setIncommingPhonenumbers(res.data);
         // console.log(res.data);
          setLoader1(false);
        }
      })
      .catch((err) => {
        console.log(err);
        //setErrormsg("wrong account_sid or api key");
        setLoader1(false);
      });
    }else{
      setIncommingPhonenumbers(null);
      setOrganization({...organization, twilio_integration: {...organization.twilio_integration, primary_phone: 'select'}})
      console.log('test',organization.twilio_integration)
      await axios
      .post(
        process.env.REACT_APP_BACKEND_URL + "twilio/get-incoming-phone-numbers",
        {...organization.twilio_integration, api_key: organization.twilio_integration.api_key.length > 200 ? organization.twilio_integration.api_key : await encryptApi(organization.twilio_integration.api_key)}
      )
      .then((res) => {
        if (res.data.length < 1) {
          setErrormsg(
            "Please add an incoming phone number in your twilio account"
          );
          setLoader1(false);
        } else {
          setIncommingPhonenumbers(res.data);
          setOrganization({...organization, twilio_integration: {...organization.twilio_integration}})
          //console.log(res.data);
          setLoader1(false);
        }
      })
      .catch((err) => {
        console.log(err);
        //setErrormsg("wrong account_sid or api key");
        setLoader1(false);
        setLoader(false);
      });
    }
   
  }

  console.log(organization);

  const [successMsg, setSuccessMsg] = useState(null)


  async function updateOrganization(){
    setErrormsg(null)

    //console.log('primary_phone',organization.twilio_integration.primary_phone)
    

    setLoader(true);
    let m = organization 
    if(m.twilio_integration.account_sid ===   process.env.REACT_APP_ACCOUNT_SID){
      m ={...organization,twilio_integration: {...organization.twilio_integration
        , test_account : true ,
        account_sid: org_data.twilio_integration.M.account_sid.S,
        api_key: (org_data.twilio_integration.M.api_key.S),
        transcription_enabled:
          organization.twilio_integration.transcription_enabled,
        auto_configuration:
          organization.twilio_integration.auto_configuration,
        primary_phone: org_data.twilio_integration.M.primary_phone.S,
      }}
    }else{
      m ={...organization,twilio_integration: {...organization.twilio_integration, test_account : false }}
    }
    //console.log(organization.twilio_integration.primary_phone.length >=2 && true)
    if(organization.twilio_integration.primary_phone.length >= 7){
        let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
                        userId: JSON.parse(localStorage.getItem('user')).userId.S
                    });
                    
                    if (check.status ===  200) {
                      const user___ = check.data.user;
                      
                
                      if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S ===  JSON.parse(localStorage.getItem('organization')).orgId.S)){
                        try {
                  
                       
                  //console.log({m})
                        
                          let organization_data = await axios
                          .post(
                            process.env.REACT_APP_BACKEND_URL + "update-organization",
                            m
                          )
                          //console.log(organization_data)
                      
                          localStorage.setItem('organization', JSON.stringify(organization_data.data.organization))
                          
                    
                          setLoader(false);
                          let org_data = organization_data.data.organization
                    
                          setSuccessMsg('Organization details updated successfully')
                          setOrganization( {
                            orgId: org_data.orgId.S,
                            organization_name: org_data.organization_name.S,
                            org_timezone: org_data.org_timezone.S,
                            twilio_integration: {
                              account_sid: org_data.twilio_integration.M.account_sid.S,
                              api_key: (org_data.twilio_integration.M.api_key.S),
                              transcription_enabled:
                                org_data.twilio_integration.M.transcription_enabled.BOOL,
                              auto_configuration:
                                org_data.twilio_integration.M.auto_configuration.BOOL,
                              primary_phone: org_data.twilio_integration.M.primary_phone.S,
                              test_account: org_data.twilio_integration.M.test_account.BOOL,
                            },
                          })
                    
                          setTimeout(() => {
                            setSuccessMsg(null)
                            //window.location.reload()
                            
                          }, 3000);
                    
                    
                        } catch (error) {
                          console.log(error);
                          if (error.response && error.response.data) {
                            console.error("Response data:", error.response.data);
                            setErrormsg(error.response.data.message);
                          }
                          setLoader(false);
                        }
                          
                      }else{
                        window.location.reload()
                      }
            
                    }
    }else{
      setErrormsg('Please add a primary phone number');
      setLoader(false);
    }
  }

  useEffect(() => {
    getIncomingPhoneNumbers();
  }, [organization.twilio_integration.account_sid, organization.twilio_integration.api_key]);
  const [users_data, setUsersData] = useState(
    JSON.parse(localStorage.getItem("organization")).users.L
  );
  const [users, setUsers] = useState([]);
  const fetchUsers = async () => {
    let users_data =  JSON.parse(localStorage.getItem("organization")).users.L
    if (users_data) {
      setLoader(true)
      const fetchedUsers = await Promise.all(
        users_data.map(async (item) => {
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
              { userId: item.M.userId.S } // Extract userId from item
            );

            // Extract and map the necessary information]
            setLoader(false)
            return {
              name: `${response.data.user.fName.S} ${response.data.user.lName.S}`,
              email: response.data.user.email.S,
              userType: item.M?.type?.S, // Extract userType from item
              status: item.M.status.S, // Extract status from item
              user_id: response.data.user.userId.S, // Extract userId
            };
          } catch (error) {
            console.error("Error fetching user:", error);
            return null; // Handle the error gracefully
            setLoader(false)
          }
        })
      );

      // Filter out any null responses and update the state
      setUsers(fetchedUsers.filter((user) => user !== null));
     // console.log('fet',fetchedUsers.filter((user) => user !== null))
    }
  };

  useEffect(() => {
   
    fetchUsers();
   // console.log('users', users)
  }, [users_data]);
  


  return (
  
    <div className="w-full px-3 lg:px-0 py-4 lg:py-0">
       {successMsg && (
               <Alert color='success' sx={{mb: 4}}>
                          <div className=" text-black-600 text-[14px] ">
                       {successMsg}
                      </div>
                        </Alert>
            )}

      {
        (users && users.filter((e)=> e.email ===  JSON.parse(localStorage.getItem('user')).email.S)[0]?.userType  !== 'user'  )? (
         <>
       
         {errorMsg && (
           <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
             <ErrorOutline sx={{ fontSize: "" }} /> {errorMsg}
           </div>
         )}
   
         {loader && (
           <div className="flex justify-center">
             <CircularProgress size={"1.2rem"}   sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
           </div>
         )}
         <div className="lg:text-[14px] text-[13px]  lg:flex items-center lg:space-x-2 lg:space-y-0 space-y-3 lg:mb-3 mb-5 ">
           <div className="lg:text-[14px] font-semibold text-[13px]">Organization Name</div>
           <InputBase
              value={organization.organization_name}
              onChange={(e) => {
                setOrganization({
                  ...organization,
                organization_name: e.target.value
                });
              }}
             sx={{
               bgcolor: "#F7F7F8",
               width: { lg: "250px", xs: "100%" },
               px: 2,
               fontSize: { lg: "14px", xs: "13px" },
             }}
           />
         </div>
   
         <div className="lg:text-[14px] text-[13px]  lg:flex items-center lg:space-x-2 lg:space-y-0 space-y-3 lg:mb-3 mb-5">
           <div className="lg:text-[14px] font-semibold text-[13px]">Timezone Settings</div>
           <div className="lg:w-[200px]">
           <TimezoneSelect  
           value={organization.org_timezone}
           onChange={(e)=>{
            setOrganization({...organization, org_timezone: e.value})
                       }} 
           className="text-[14px]   "
               styles={{
                control: (provided) => ({
                  ...provided,
                  backgroundColor: '#F7F7F8',
                  borderColor: 'transparent',
                  boxShadow: 'none',
                  fontSize: '14px',
                  width: 'full',
                  '@media (max-width: 1024px)': {
                    fontSize: '12px',
                    width: 'full', // Adjust the height for smaller screens
                  },
                  '&:hover': {
                    borderColor: 'transparent',
                  },
                }),
                menu: (provided) => ({
                  ...provided,
                  backgroundColor: '#F7F7F8',
                  // Remove border from the dropdown menu
                }),
                indicatorSeparator: (provided) => ({
                  display: 'none', // Remove the indicator separator
                }),

              
              }}
             />
             {/* <Select
               fullWidth
               value={organization.org_timezone}
              onChange={(e) => {
                setOrganization({
                  ...organization,
                org_timezone: e.target.value
                });
              }}
               className="mb-2 bg-[#F7F7F8]"
               sx={{
                 fontSize: { lg: "14px", xs: "13px" },
                 padding: "2px 8px", // Adjust padding here
                 "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                 "& .MuiSelect-select": {
                   padding: "2px 8px", // Adjust padding for the text inside Select
                 },
               }}
             >
              {timezones.map((item,index)=> {
                console.log(timezones.filter((e)=> e.tzCode.includes('New')))
                return(
                  <MenuItem value={item.tzCode} >{item.tzCode}</MenuItem>
                )
              })}
             </Select> */}
           </div>
         </div>
   
         <div className="lg:text-[14px] underline font-semibold text-[13px]  mb-3 mt-5">
           Twilio Settings
         </div>


         <div className="flex  mb-4 lg:text-[12px] text-[12px] lg:w-[600px] mb-2">
           Where to find your Twilio Credentials{" "}
           <OpenInNew
             sx={{
               color: "#605BFF",
               fontSize: { lg: "14px", xs: "13px" },
               position: "relative",
               top: 3,
               ml: 1,
               cursor: "pointer",
             }}
           />
         </div>
   
         <div className="flex items-center space-x-2 space-y-1 mb-3">
           <div className=" lg:text-[14px] text-[13px] font-semibold ">Account SID</div>
           <InputBase
             value={organization.twilio_integration.account_sid}
             onChange={(e) => {
               setOrganization({
                 ...organization,
                 twilio_integration: {
                   ...organization.twilio_integration,
                   account_sid: e.target.value,
                 },
               });
             }}
             sx={{
               bgcolor: "#F7F7F8",
               width: "100%",
               px: 2,
               py: "2px",
               fontSize: "14px",
               width: { lg: "250px", xs: "100%" },
             }}
           />
         </div>
   
       
   
         <div className="flex items-center space-x-2 space-y-1 mb-3">
           <div className=" lg:text-[14px] text-[13px] font-semibold ">Auth Token</div>
   
           <InputBase
             type={ "password"}
            //  type='text'
             value={organization.twilio_integration.api_key}
             onChange={(e) => {
               setOrganization({
                 ...organization,
                 twilio_integration: {
                   ...organization.twilio_integration,
                   api_key: e.target.value,
                 },
               });
             }}
              // endAdornment={
              //   <InputAdornment
              //     position="end"
              //     onClick={handleTogglePassword}
              //     className="cursor-pointer"
              //   >
              //     {showPassword ? <VisibilityOff /> : <Visibility />}
              //   </InputAdornment>
              // }
             sx={{
               bgcolor: "#F7F7F8",
               width: "100%",
               px: 2,
               py: "2px",
               fontSize: "14px",
               width: { lg: "250px", xs: "100%" },
             }}
           />
         </div>
   
         <div className="space-y-1 mb-3">
           <div className="flex space-x-2 items-center">
             <div className=" lg:text-[14px] font-semibold text-[13px] ">
               Primary Phone Number
             </div>
             <div className=" space-x-2">
               {loader1 ? (
                 <img
                   src="/icons/loading-spinner.gif"
                   className="w-[24px] ml-4 cursor-pointer"
                 />
               ) : (
                 <Button
                   sx={{
                     textTransform: "none",
                     bgcolor: "#605BFF",
                     color: "white",
                     py: "1px",
                     px: "10px",
                     borderRadius: "7px",
                     fontSize: { lg: "14px", xs: "13px" },
                   }}
                   onClick={getIncomingPhoneNumbers}
                   disabled={loader1}
                 >
                   {loader1 ? (
                     <CircularProgress size={"1rem"} sx={{ color: "white" }} />
                   ) : (
                     <Cached size={"1rem"} sx={{ color: "white" }}/>
                   )}
                 </Button>
               )}
             </div>
           </div>
   
           <div className="text-[11px] my-1">
             The main phone number you’d like to setup call forwarding for. You can
             change this later in settings.
           </div>
           <div className="lg:w-full w-[82vw]">
             <Select
               IconComponent={KeyboardArrowDown}
               fullWidth
               className="mb-2 bg-[#F7F7F8]"
               value={ incomming_phonenumbers?.filter((e)=> e.phoneNumber ===  organization.twilio_integration.primary_phone) ? organization.twilio_integration.primary_phone : 'select'}
               onChange={(e) => {
                 setOrganization({
                   ...organization,
                   twilio_integration: {
                     ...organization.twilio_integration,
                     primary_phone: e.target.value,
                   },
                 });
               }}
               sx={{
                 fontSize: "14px",
                 padding: "4px 8px", // Adjust padding here
                 "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                 "& .MuiSelect-select": {
                   padding: "4px 8px", // Adjust padding for the text inside Select
                 },
                 width: { lg: "250px", xs: "100%" },
               }}
             >
               <MenuItem value="select" disabled>Select a phone number</MenuItem>
               {/* {incomming_phonenumbers &&
                 incomming_phonenumbers.map((item, index) => (
                   <MenuItem value={item.phoneNumber}>{formatPhoneNumber(item.phoneNumber)}</MenuItem>
                 ))} */}


{incomming_phonenumbers &&
incomming_phonenumbers.filter((e)=> organization.twilio_integration.account_sid ===   process.env.REACT_APP_ACCOUNT_SID ? e.phoneNumber ===   organization.twilio_integration.primary_phone : e).map((item, index) => (
 <MenuItem value={item.phoneNumber}>{formatPhoneNumber(item.phoneNumber)}</MenuItem>
))}
                
             </Select>
           </div>
         </div>
   
         <div className="flex my-2 items-center">
           <div>
             <Checkbox
               checked={organization.twilio_integration.transcription_enabled}
               onChange={(e) => {
                 setOrganization({
                   ...organization,
                   twilio_integration: {
                     ...organization.twilio_integration,
                     transcription_enabled: e.target.checked,
                   },
                 });
               }}
               size="lg"
               sx={{
                 color: "#605BFF",
                 "&.Mui-checked": {
                   color: "#605BFF", // Set color for checked state
                 },
               }}
             />
           </div>
   
           <div className="lg:text-[14px] text-[13px]  flex items-center">
             Enable Twilio Transcription
             <Tooltip
                   title="Twilio Transcription is a setting where we will ask Twilio to transcribe your Voicemails. Twilio may charge for this. "
                   arrow
                 >
                   <img src="/icons/tooltip.png" className="w-[15px] lg:ml-3 " />
                 </Tooltip>
           </div>
         </div>
   
         <div className="flex my-2 items-center mb-16 lg:mb-0">
           <div>
             <Checkbox
               
                checked={organization.twilio_integration.auto_configuration}
               onChange={(e) => {
                 setOrganization({
                   ...organization,
                   twilio_integration: {
                     ...organization.twilio_integration,
                     auto_configuration: e.target.checked,
                   },
                 });
               }}
               size="lg"
               sx={{
                 color: "#605BFF",
                 "&.Mui-checked": {
                   color: "#605BFF", // Set color for checked state
                 },
               }}
             />
           </div>
   
           <div className="lg:text-[14px] text-[13px]  flex items-center">
             Twilio Autoconfiguration
             <Tooltip
                   title="Twilio Autoconfiguration is a setting where we will
                    automatically update your Twilio numbers to point to call
                     routes set up in Twilanswer. It is recommended to be enabled"
                   arrow
                 >
                   <img src="/icons/tooltip.png" className="w-[15px] lg:ml-3 " />
                 </Tooltip>
           </div>
         </div>
   
         <div className="flex justify-end pt-5 lg:relative absolute right-10 bottom-10 lg:bottom-0 ">
           <Button
             sx={{
               textTransform: "none",
               bgcolor: "#605BFF",
               color: "white",
               py: { lg: "10px", xs: "5px" },
               px: "20px",
               borderRadius: "12px",
               fontSize: { lg: "14px", xs: "12px" },
               height: "fit",
             }}
             onClick={updateOrganization}
             disabled={ loader1  && loader}
           >
              {loader ? (
                     <CircularProgress size={"1rem"} sx={{ color: "white" }} />
                   ) : (
                     "  Save Changes"
                   )}
            
           </Button>
         </div>
   
        </>
        ): (
          <Alert color='warning'>
            <div className=" text-black-600 text-[14px] ">
         You can't view this page in this organization because your type is user
        </div>
          </Alert>
        )
      }
      
    </div>
  );
};

export default Organization;
